// axios
import axios from 'axios'

// var baseURL = '';
// if(process.env.NODE_ENV != 'production'){
//   baseURL = "http://127.0.0.1:8000/api/";
// }else{
//   baseURL = "/api/";
// }

const baseURL = '/api/'

export default axios.create({
  baseURL
  // You can add your headers here
})
